function formatSiteDataForML(siteData: SiteData): SiteDataForML {
    let siteDataForML: any = siteData.siteSpecificData
    return siteDataForML
}

export default formatSiteDataForML